import { useTranslation } from 'react-i18next';

export const keyPrefix = 'departmentUserList';
export const useDepartmentUserListTranslation = () => useTranslation('widgets', { keyPrefix });
export const ruRu = (__LOCALE_RU__ ? ({
  [keyPrefix]: {
    title: 'Пользователи',
  },
}) : {}) as Record<string, unknown>;
export const en = (__LOCALE_EN__ ? ({
  [keyPrefix]: {
    title: 'Users',
  },
}) : {}) as Record<string, unknown>;
export const esEs = (__LOCALE_ESES__ ? ({
  [keyPrefix]: {
    title: 'Usuários',
  },
}) : {}) as Record<string, unknown>;
export const ptBr = (__LOCALE_PTBR__ ? ({
  [keyPrefix]: {
    title: 'Usuarios',
  },
}) : {}) as Record<string, unknown>;
